import { Component, Input, OnInit, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
// import { ModalAddPoliceComponent } from "src/app/parametres/param-production/police/modal-add-police/modal-add-police.component";


@Component({
  selector: 'app-garant-detail-police',
  templateUrl: './garant-detail-police.component.html',
  styleUrls: ['./garant-detail-police.component.scss']
})
export class GarantDetailPoliceComponent implements OnInit {

  listItems: Array<any> = [];
  @Input() garantData:any
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "police";
  title: string = "police";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];

  gender = "F";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeRemboursement: any;
  itemsCourtier: any[];
  itemsCommercial: any;
  itemsSouscripteur: any;
  itemsCategoriePolice: any[];
  itemsGarant: any;
  itemsPrestataireCheked: any[];
  itemsPrestatairereseauDeSoin: any[];
  itemGarant: any;
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.deleteMessage =
      "Vous êtes sur le point de supprimer " + text1 + " " + this.title;
  }

  pageChanged(event: any): void {
    this.currentPage = event.page - 1;
    this.getItems();
  }
  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log('changes: ',changes)

    if (changes.garantData.currentValue) {
      setTimeout(() => {

        let garant = changes.garantData.currentValue
        // this.itemGarant = changes.garantData.currentValue
        this.itemToSearch.garant_id = garant.id
        this.getItems()
        
          });
    }
    
  }

  openModal(data: any, template: TemplateRef<any>) {
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-60",
    };
    this.itemToSave = {};
    if (data) {
      this.itemToSave = Object.assign({}, data);
    }

    this.modalRef = this.modalService.show(template, config);
  }

  

  // openModalReseau() {
  //   if(!this.itemGarant.reseau_de_soin_id)
  //     return
  //   let modal: any;
  //   modal = ModalViewreseauDeSoinDetailComponent;
  //   this.modalRef = this.modalService.show(modal, {
  //     id: 54581554500,
  //     class: "modal-width-75",
  //     ignoreBackdropClick: true,
  //     // data:boulangerie
  //   });
 
  //   let data = {reseau_de_soin_id:this.itemGarant.reseau_de_soin_id,reseau_de_soin_libelle:this.itemGarant.reseau_de_soin_libelle}
  //   if (data) this.modalRef.content.currentData = data;
  //   this.modalRef.onHide.subscribe((res) => {
  //   });
  
  
  // }
  
  openModalPrestataireReseau(data: any) {
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 5,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      // this.getItems();
    });
  }

  getItems() {

    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      data: { ...this.clearObject(this.itemToSearch) },
      index: this.currentPage,
      size: this.itemsPerPage,
    };

    this.busyGet = this.restClient
      .post(this.endPoint + "/getByCriteria", request)
      .subscribe(
        (res) => {
          // debugger
          if (res && res["items"] && !res["hasError"]) {
            this.items = res["items"];
            
            this.totalItems = res["count"];
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.items = [];
            this.totalItems = 0;
          }
        },
        (err) => {}
      );
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }

  getItemsGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarant = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsGarant = [];
          }
        },
        (err) => {
          this.itemsGarant = [];
        }
      );
  }

  confirmDelete(item) {
    Swal.fire({
      title: this.capitalize(this.title),
      text: this.deleteMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3f51b5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.deleteItem(item);
      }
    });
  }

  deleteItem(obj) {
    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [obj],
    };

    this.busyGet = this.restClient
      .post(this.endPoint + "/delete", request)
      .subscribe(
        (res) => {
          console.info(res);
          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.currentPage = 0;
            this.getItems();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          console.info("Error occured", err);
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
        }
      );
  }

  changePaginationSize($event) {
    if ($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }

  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  load_filiale_data() {
    this.getItems();
  }

  getItemsReseauDeSoinPrestataire(id, template, config) {
    this.itemsPrestatairereseauDeSoin = [];
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 10,
      // order_by:'libelle',
      // search_key: this.searchKeyPrestataire,
      data: {
        reseau_de_soin_id: id,
      },
    };

    this.busyGet = this.restClient
      .post("reseauDeSoinPrestataire/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            // if(res["items"].length){
            //   res['items']
            // }
            this.itemsPrestatairereseauDeSoin = [...res["items"]];
          } else {
            this.itemsPrestatairereseauDeSoin = [];
          }
          this.modalRef = this.modalService.show(template, config);
        },
        (err) => {
          this.itemsPrestatairereseauDeSoin = [];
        }
      );
  }

  ngOnInit() {
    this.resetForm();
    // this.getItems();
    this.getItemsFiliale();
    // this.getItemsGarant();
  }

  clearObject(obj) {
    return Object.keys(obj).reduce((acc, key) => {
      if (obj[key] !== null && obj[key] !== undefined) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  }

  // openAddItemModal(data?) {
  //   let modal: any;
  //   modal = ModalAddPoliceComponent;
  //   this.modalRef = this.modalService.show(modal, {
  //     id: 5,
  //     class: "modal-width-75",
  //     ignoreBackdropClick: true,
  //     // data:boulangerie
  //   });
  //   if (data) this.modalRef.content.currentData = data;
  //   this.modalRef.onHide.subscribe((res) => {
  //     this.currentPage = 0
  //     this.getItems();
  //   });
  // }

}
